<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-select style="width: 145px" @change="changeData($event,'state')" @clear="clearsearch('gs')" class="marr4" v-model="vc_checkstate" size="mini" clearable filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in stateData"
                        :key="item.i_checkstate"
                        :label="item.vc_name"
                        :value="item.i_checkstate">
                </el-option>
            </el-select>
            <el-select style="width: 145px" @change="changetype" class="marr4" v-model="i_invoiceType" size="mini" filterable :placeholder="$t('saleInvoicing_please_select')">
                <el-option
                        v-for="item in typeList"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  @change="changeData($event,'fpt')"
                       @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable
                       filterable :placeholder="$t('invoiceEntry_please_select_the_billing_type')">
                <el-option
                        v-for="item in fpType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  @change="changeData($event,'gs')"
                       @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable
                       filterable :placeholder="$t('form_please_select_a_company')">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-input  class="marr4" style="width: 370px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_customer_name/invoice_number/product_name/submitter_search')" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="goDd('add')">{{$t('invoiceEntry_add_invoice')}}</el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="getxh('add')">{{$t('invoiceEntry_invoice_write-off')}}</el-button>
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="goFl('add')">{{$t('invoiceEntry_new_rebate_invoice')}}</el-button>
            <!--<el-button :class="baseerp+'btn'"  size="small" type="primary" @click="getxh('has')">核销明细</el-button>-->
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="typeTxt"
                    :label="$t('invoiceEntry_billing_type')"
                    show-overflow-tooltip
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_fptype"
                    :label="$t('invoiceEntry_invoice_type')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <!--<el-table-column
                    prop="i_invoiceType"
                    :label="$t('invoiceEntry_invoice_type')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_invoiceType==1?"蓝字":(scope.row.i_invoiceType==2?"红字":"")}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="vc_checkstate"
                    :label="$t('form_state')"
                    width="80px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_fpcode"
                    :label="$t('invoiceEntry_invoice_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pm"
                    :label="$t('invoiceEntry_project')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_pay"
                    :label="$t('invoiceEntry_total_amount')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="vc_kpkhname"
                    :label="$t('invoiceEntry_issuer')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('invoiceEntry_payer')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_fptime"
                    :label="$t('invoiceEntry_invoice_time')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="$t('invoiceEntry_submitter')"
                    show-overflow-tooltip
                    width="118">
            </el-table-column>
            <el-table-column
                    prop="vc_mainfile_newname"
                    :label="$t('form_attachment')"
                    show-overflow-tooltip
                    width="60px">
                <template slot-scope="scope">
                    <a v-for="item in scope.row.files" :href="file_root+item.vc_mainfile_newname" target="_blank">
                        <i class="el-icon-paperclip" v-show="item.vc_mainfile_newname"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    width="60"
                    :label="$t('form_operate')">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.i_type==21"  type="text" size="small" @click="goFl('edit',scope.row)">{{$t('button_edit')}}</el-button>
                    <el-button v-else type="text" size="small" @click="goDd('edit',scope.row)">{{$t('button_edit')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="5vh"
                :class="baseerp+'div'"
                width="90%"
                :title="title"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible">
            <sure-ordernew ref="sureOrder" :Data="Data" @cancelDialog="cancelDialog"></sure-ordernew>
        </el-dialog>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="5vh"
                :class="baseerp+'div'"
                width="90%"
                :title="$t('invoiceEntry_in_transit_invoice')"
                :visible.sync="dialogVisible_zt"
                :close-on-click-modal="false"
                @close="ztconfirm({type:'back'})"
                v-if="dialogVisible_zt">
            <ztfp-list ref="ztfp" :ztData="ztData" @confirm="ztconfirm"></ztfp-list>
        </el-dialog>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="5vh"
                :class="baseerp+'div'"
                width="90%"
                :title="title"
                :visible.sync="dialogVisible_fl"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible_fl">
            <sure-ordernewfl ref="sureOrder" :Data="Data" @cancelDialog="cancelDialog"></sure-ordernewfl>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import sureOrdernew from "./sureOrdernew";
    import ztfpList from "./ztfpList";
    import sureOrdernewfl from "./sureOrdernewfl";
    export default {
        components: {
            sureOrdernew,
            ztfpList,
            sureOrdernewfl
        },
        data() {
            return {
                maxDialogHeight: 0,
                baseerp:"",
                file_root:"",
                mid:0,
                treespan:5,
                rightspan:19,
                isright:true,
                Data:{},
                ztData:{},
                title:this.$t('invoiceEntry_invoice_processing'),
                dialogVisible:false,
                dialogVisible_zt:false,
                dialogVisible_fl:false,
                loading:false,
                tableHeight:0,
                fpType:[
                    /*{i_type:2,vc_type:"采购发票"},
                    {i_type:3,vc_type:"运费发票"},
                    {i_type:32,vc_type:"港杂发票"},
                    {i_type:4,vc_type:"开证发票"},
                    {i_type:5,vc_type:"仓储发票"},
                    {i_type:6,vc_type:"保险发票"},*/
                ],
                i_type:0,
                i_khtype:0,
                vc_type:"",
                stateData:[
                    // {isover:'4',vc_name:'待处理'},
                    {i_checkstate:'0',vc_name:this.$t('state_tobe_submitted')},
                    {i_checkstate:'1',vc_name:this.$t('state_review_approved')},
                    {i_checkstate:'3',vc_name:this.$t('state_reviewing')},
                    {i_checkstate:'-2',vc_name:this.$t('state_review_not_approved')},
                ],
                //isover:'0',
                //vc_isover:this.$t('state_tobe_submitted'),
                i_checkstate:"0",
                vc_checkstate:this.$t('state_tobe_submitted'),
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                tableData:[{}],
                highlightCurrentRow:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                page:'normal',
                i_invoiceType:0,
                typeList:[{i_id:1,vc_name:this.$t('saleInvoicing_blue_text')},{i_id:2,vc_name:this.$t('saleInvoicing_scarlet_letter')},{i_id:0,vc_name:this.$t('saleInvoicing_all')}]

            }
        },
        watch: {
        },
        activated(){

        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            ///this.getfMou();
            this.fptype();
            this.getCompanyList();
            //this.ztfpList()
            //this.getList(1);

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            /*closeTree(){
                this.treespan=0;
                this.rightspan=24;
                this.isright=false;
            },*/
            /*openTree(){
                this.treespan=5;
                this.rightspan=19;
                this.isright=true;
            },*/
            getColumnAlign(column) {
                // 判断列的属性，如果是数值类型，返回右对齐样式
                if (column === 'num') {
                    return 'right';
                }

            },

            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                const otherHeight =230;
                this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            changetype(e){
                // console.log(e);
                this.i_invoiceType=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            ztconfirm(type){
                this.dialogVisible_order = false;
                if (type == 'save') {
                    this.ztfpList();
                }
            },
            getxh(type){
                //console.log('type',type);
                if(type=='add'){
                    this.ztfpList()
                }
                if(type=='has'){

                }
            },
            goDd(type,row){
                this.page='normal';
                //console.log('row',row);
                if(type=="add"){
                    this.title=this.$t('invoiceEntry_add_invoice')
                }else if(type=='edit'){
                    this.title=this.$t('invoiceEntry_edit_invoice')+row.vc_fpcode;
                }
                let map={
                    type:type,
                    row:row,
                    maxDialogHeight:this.maxDialogHeight,
                }
                this.Data=map;
                this.dialogVisible=true;
            },
            goFl(type,row){
                this.page='fl';
                //console.log('row',row);
                if(type=="add"){
                    this.title=this.$t('invoiceEntry_new_rebate_invoice');
                }else if(type=='edit'){
                    this.title=this.$t('invoiceEntry_edit_rebate_invoice')+row.vc_fpcode;
                }
                let map={
                    type:type,
                    row:row,
                    maxDialogHeight:this.maxDialogHeight,
                }
                this.Data=map;
                this.dialogVisible_fl=true;
            },
            cancelDialog(val){
                //console.log(val,'valllll')
                this.Data={};
                if(this.page=='normal')this.dialogVisible=false;
                if(this.page=='fl')this.dialogVisible_fl=false;
                if(val){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList(1);
                }
            },
            //查询开票类型
            async fptype(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                    isCw:0,
                    typeList :[0,1,2,3],
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.getfMou();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    //i_khtype:this.i_khtype,
                    i_khtype:this.i_khtype==0?'3,4,5,6,7,8,9':this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            output(){
                let map={
                    i_gsid:this.companyId,
                    dt_startdate:this.dt_startdate,
                    dt_enddate:this.dt_enddate,
                    vc_search:this.vc_search,
                };
                this.$emit("outputdata",map);
            },
            /*addTd(){
                this.$emit('openTree')
            },*/
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        //this.getkhlist();
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                    //刷新列表
                }
                if(type=='state'){
                    this.i_checkstate=e;
                    let choo = this.stateData.filter(item=>{
                        return item.i_checkstate == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_checkstate=choo[0].vc_name;
                    }else{
                        this.vc_checkstate='';
                    }
                    //刷新列表
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                        }else{
                            this.vc_kpkhname='';
                        }
                        //刷新列表
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                    //刷新列表
                }
                this.getList();
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.i_checkstate=null;
                    this.vc_checkstate='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            async ztfpList(){
                let param={
                    'i_mid':this.mid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                };
                var res = await API.getInvoiceInTransitList(param);
                if (res.code==1){
                    //console.log('res.data',res)
                    if(res.data.list.length>0){
                        this.ztData={
                            data:res.data.list,
                            maxDialogHeight:this.maxDialogHeight,
                        }
                        this.dialogVisible_zt=true;
                    }else{
                        this.$message.success(this.$t('invoiceEntry_there_are_currently_no_invoices_available_for_verification'));
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //列表list
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    'i_type':this.i_type,
                    'i_checkstate':this.i_checkstate,
                    "i_gsid": this.companyId,
                    'i_kpkhid':this.i_kpkhid,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'i_invoiceType':this.i_invoiceType,
                };
                var res = await API.list(param);
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    res.data.list.map(item=>{
                        let files=[];
                        let arr = item.vc_mainfile_newname.split(';')
                        arr.map((subitem,subindex)=>{
                            let map={}
                            map.vc_mainfile_newname=subitem;
                            map.vc_filename=item.vc_fpcode+'_'+subindex;
                            files.push(map)
                        })
                        item.files=files;
                    });
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                    //this.ztfpList()
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    .pm{
        height: calc(100vh - 145px);
        /*overflow: auto;*/
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }
    //css
    //弹窗窗口
    /deep/.cgdia {
        .el-dialog {
            max-height: 90vh !important;    /* 弹窗最大高度为视口高度的90% */
            overflow: auto;        /* 内容超出时滚动 */
        }
        .el-dialog__body {
            max-height: calc(90vh - 100px) !important;/* 减去头部和底部的空间 */
            overflow-y: auto;
            padding: 0 20px 0 20px;
        }
        .el-dialog__headerbtn .el-dialog__close{
            color: white;
        }
        .el-dialog__title{
            color: white;
        }

    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>